import React from 'react';
import styled from 'styled-components';
import { ImCheckmark as CheckMark } from 'react-icons/im';

type Props = {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const Checkbox: React.FC<Props> = ({ checked, onChange, id }) => {
  return (
    <Wrapper>
      <input
        type="checkbox"
        checked={checked}
        id={id}
        onChange={(e) => {
          onChange(e.target.checked);
        }}
      />
      <span>
        <CheckMark />
      </span>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  display: inline-block;
  min-height: 17px;
  min-width: 17px;

  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
    z-index: 1;
  }

  span {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 17px;
    height: 17px;
    border: 1px solid #d4d4d5;
    border-radius: 3px;
    background: #fff;
    cursor: pointer;
    transition: border 0.1s ease;

    svg {
      font-size: 13.5px;
      color: rgba(0, 0, 0, 0.87);
      opacity: 0;
      transition: opacity 0.1s ease;
    }
  }

  input[type='checkbox']:checked + span {
    background: #fff;
    border-color: rgba(34, 36, 38, 0.35);

    svg {
      opacity: 1;
    }
  }

  input[type='checkbox']:hover + span {
    border-color: rgba(34, 36, 38, 0.35);
  }
`;
